const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const assignment = () => import(/* webpackPrefetch: true */ '@/views/private/assignment/index.vue')
const attendance = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/index.vue')
const candidate = () => import(/* webpackPrefetch: true */ '@/views/private/candidate/index.vue')
const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/detail.vue')
const announcement = () => import(/* webpackPrefetch: true */ '@/views/private/announcement/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')
const radius = () => import(/* webpackPrefetch: true */ '@/views/private/radius/index.vue')

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard,
    meta: {
      title: "Beranda"
    }
  },
  {
    path: "/assignment",
    name: "assignment",
    component: assignment,
    meta: {
      title: "Penugasan"
    }
  },
  {
    path: "/attendance",
    name: "attendance",
    component: attendance,
    meta: {
      title: "Absensi"
    }
  },
  {
    path: "/candidate",
    name: "candidate",
    component: candidate,
    meta: {
      title: "Calon Peserta"
    }
  },
  {
    path: "/user/:id",
    name: "user detail",
    component: user_detail,
    meta: {
      title: "Detail Pengguna"
    }
  },
  {
    path: "/user",
    name: "user",
    component: user,
    meta: {
      title: "Pengguna"
    }
  },
  {
    path: "/announcement",
    name: "announcement",
    component: announcement,
    meta: {
      title: "Pengumuman"
    }
  },
  {
    path: "/profile",
    name: "profile",
    component: profile,
    meta: {
      title: "Profil Saya"
    }
  },
  {
    path: "/radius",
    name: "radius",
    component: radius,
    meta: {
      title: "Config Radius"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})